import { render, staticRenderFns } from "./IePrompt.vue?vue&type=template&id=6f68184a&scoped=true&"
import script from "./IePrompt.vue?vue&type=script&lang=js&"
export * from "./IePrompt.vue?vue&type=script&lang=js&"
import style0 from "./IePrompt.vue?vue&type=style&index=0&id=6f68184a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68184a",
  null
  
)

export default component.exports